// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* accordion */
.accordion {
  margin-bottom: calc(var(--cms-margin) * 1px) !important;
  border: 1px solid var(--cms-color-border, #d9d9d9);
  border-radius: calc(var(--cms-border-radius) * 1px);
  overflow: hidden;
  padding: calc(var(--cms-padding-xxs) * 1px) !important;
}

.accordion .accordion-content {
  height: unset !important;
  overflow: hidden;
  padding: 0;
  transition: height 500ms ease-out;
}

.accordion[data-open='false'] .accordion-content {
  height: 0px !important;
  overflow: hidden;
  padding: 0;
}

.accordion .accordion-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.accordion-title .accordion-title-content div[data-accordion-title] {
  position: relative;
}

.accordion-content div[data-accordion-content] > p {
  position: relative;
  padding-left: 28px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  margin: 0 !important;
}

.accordion
  .accordion-title
  div[data-accordion-title][data-accordion-placeholder]:has(br.ProseMirror-trailingBreak)::after {
  content: attr(data-accordion-placeholder);
  position: absolute;
  top: 0;
  pointer-events: none;
  user-select: none;
  color: #999;
}

.accordion
  .accordion-content
  div[data-accordion-content][data-accordion-placeholder]
  > p:has(br.ProseMirror-trailingBreak)::after {
  content: var(--data-accordion-placeholder);
  position: absolute;
  top: 8px;
  pointer-events: none;
  user-select: none;
  color: #999;
}

.accordion-title .accordion-title-icon {
  border-radius: 4px;
  width: 20px;
  height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transition: background-color 300ms ease;
  cursor: default;
}

.accordion-title .accordion-title-icon:hover {
  background-color: var(--cms-color-bg-container-disabled) !important;
}
`, "",{"version":3,"sources":["webpack://./../editor/src/extensions/AccordionExtension.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,uDAAuD;EACvD,kDAAkD;EAClD,mDAAmD;EACnD,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;;;EAGE,yCAAyC;EACzC,kBAAkB;EAClB,MAAM;EACN,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;;EAIE,0CAA0C;EAC1C,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,mEAAmE;AACrE","sourcesContent":["/* accordion */\n.accordion {\n  margin-bottom: calc(var(--cms-margin) * 1px) !important;\n  border: 1px solid var(--cms-color-border, #d9d9d9);\n  border-radius: calc(var(--cms-border-radius) * 1px);\n  overflow: hidden;\n  padding: calc(var(--cms-padding-xxs) * 1px) !important;\n}\n\n.accordion .accordion-content {\n  height: unset !important;\n  overflow: hidden;\n  padding: 0;\n  transition: height 500ms ease-out;\n}\n\n.accordion[data-open='false'] .accordion-content {\n  height: 0px !important;\n  overflow: hidden;\n  padding: 0;\n}\n\n.accordion .accordion-title {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n}\n\n.accordion-title .accordion-title-content div[data-accordion-title] {\n  position: relative;\n}\n\n.accordion-content div[data-accordion-content] > p {\n  position: relative;\n  padding-left: 28px !important;\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n  margin: 0 !important;\n}\n\n.accordion\n  .accordion-title\n  div[data-accordion-title][data-accordion-placeholder]:has(br.ProseMirror-trailingBreak)::after {\n  content: attr(data-accordion-placeholder);\n  position: absolute;\n  top: 0;\n  pointer-events: none;\n  user-select: none;\n  color: #999;\n}\n\n.accordion\n  .accordion-content\n  div[data-accordion-content][data-accordion-placeholder]\n  > p:has(br.ProseMirror-trailingBreak)::after {\n  content: var(--data-accordion-placeholder);\n  position: absolute;\n  top: 8px;\n  pointer-events: none;\n  user-select: none;\n  color: #999;\n}\n\n.accordion-title .accordion-title-icon {\n  border-radius: 4px;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 300ms ease;\n  cursor: default;\n}\n\n.accordion-title .accordion-title-icon:hover {\n  background-color: var(--cms-color-bg-container-disabled) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
